import { createContext } from "react";
import { defaultTiltifyConfig, type TiltifyConfig } from "@/hooks/useTiltifyConfig";
import type { ChangeEventLike } from "@/util/localStorageConfig.ts";

export interface TiltifyConfigContextValue {
  config: TiltifyConfig;
  setField: <K extends keyof TiltifyConfig>(key: K, value: TiltifyConfig[K]) => void;
  setFromEvent: (e: ChangeEventLike) => void;
  clearField: (key: keyof TiltifyConfig) => void;
}

export const TiltifyConfigContext = createContext<TiltifyConfigContextValue>({
  config: defaultTiltifyConfig,
  setField: () => {},
  setFromEvent: () => {},
  clearField: () => {},
});
